<a class="navbar-brand d-flex align-items-center align-content-center">
  <a [routerLink]="'/' + selectedCompanyGroup + homepage">
    @if (selectedCompanyGroup === 'ANL') {
      <app-accentry-logo
        [@enterAnimation]
        [isTopLogo]="true"
      ></app-accentry-logo>
    }
    @if (selectedCompanyGroup === 'GHO') {
      <img
        [@enterAnimation]
        class="logo"
        src="./assets/images/Ghost-logo.png"
        alt="Ghost - Accentry"
        title="Ghost - Accentry"
        />
    }
    @if (selectedCompanyGroup === 'VAR') {
      <img
        [@enterAnimation]
        class="logo logo-svg"
        src="./assets/images/tunturi-accell-white.png"
        alt="Tunturi Sweden - Accentry"
        title="Tunturi Sweden - Accentry"
        />
    }
    @if (selectedCompanyGroup === 'LAP') {
      <img
        [@enterAnimation]
        class="logo"
        src="./assets/images/accell-sud.png"
        alt="Lapierre - Accentry"
        title="Accell Sud"
        />
    }
    @if (selectedCompanyGroup === 'COM') {
      <img
        [@enterAnimation]
        class="logo"
        src="./assets/images/Comet-logo-white.png"
        alt="Comet - Accentry"
        title="Comet - Accentry"
        />
    }
    @if (selectedCompanyGroup === 'TUN') {
      <img
        [@enterAnimation]
        class="logo logo-svg"
        src="./assets/images/Tunturi-logo.png"
        alt="Tunturi - Accentry"
        title="Tunturi - Accentry"
        />
    }
    @if (
      selectedCompanyGroup === 'WG'
      ) {
      <img
        [@enterAnimation]
        class="logo winora"
        style="height: 40px"
        src="./assets/images/Winora-logo.png"
        alt="Winora - Accentry"
        title="Winora - Accentry"
        />
    }
    @if (selectedCompanyGroup === 'RAL') {
      <img
        [@enterAnimation]
        class="logo logo-svg"
        src="./assets/images/logos/accell-uk-white.png"
        alt="Raleigh"
        title="Raleigh"
        style="min-height: 42px"
        />
    }
  </a>
  @if (availableCompanyGroups.length > 1) {
    <span
      (click)="toggleCompanyDropdown(); t.close()"
      class="company-group-dropdown-button d-flex align-content-center ms-2"
      style="cursor: pointer"
      >
      <span
        class="material-icons d-flex align-content-center align-self-center dropdown-icon"
        [ngbTooltip]="'SELECT_COMPANY' | translate"
        placement="bottom"
        #t="ngbTooltip"
        >
        arrow_drop_down
      </span>
    </span>
  }
  <app-brand-selector [hidden]="!showCompanyDropdown" (brandClicked)="showCompanyDropdown = false"></app-brand-selector>
</a>
